import { FormSchema } from 'src/hooks';
import { GetApproverMakerData } from 'src/models';
import auth from 'src/utilities/auth';
import { MultiApprovalData } from './types';

export const hundredTrillion = 100000000000000;

export const LABEL = {
  placeholder: {
    amount1: 'Rp 0',
    amount2: 'Rp 100.000',
    amount3: 'Rp 10.000.000',
  },
  message: {
    firstInformation: 'Perubahan akan efektif setelah klik tombol simpan',
    secondInformation:
      'Transaksi yang sudah berjalan masih akan menggunakan struktur approval sebelumnya',
    emptyApprover: 'Masukan username untuk approver level ',
    dataNotValid: 'Data Not Valid.',
  },
  value: {
    true: 'true',
    false: 'false',
    instant: 'instant',
    yes: 'yes',
    no: 'no',
    zero: 0,
    maxLevel: 3,
    level1: 1,
    level2: 2,
    level3: 3,
  },
};

export const AccountOptions = [
  {
    value: 'pejetAJa',
    label: 'pejetaja',
  },
  {
    value: 'anugrahPrasetia',
    label: 'anugrahprasetia',
  },
  {
    value: 'anugrahPejet',
    label: 'anugrahpejet',
  },
];

export enum MultiApprovalFieldName {
  MinAmount1 = 'minAmount1',
  MinAmount2 = 'minAmount2',
  MinAmount3 = 'minAmount3',
  Approver1 = 'approver1',
  Approver2 = 'approver2',
  Approver3 = 'approver3',
}

export const MULTI_APPROVAL_SCHEMA: FormSchema = {
  [MultiApprovalFieldName.MinAmount1]: {
    initialValue: LABEL.value.zero,
    validationRule: 'required',
  },
  [MultiApprovalFieldName.MinAmount2]: {
    initialValue: LABEL.value.zero,
    validationRule: 'required',
  },
  [MultiApprovalFieldName.MinAmount3]: {
    initialValue: LABEL.value.zero,
    validationRule: 'required',
  },
  [MultiApprovalFieldName.Approver1]: {
    initialValue: '',
    validationRule: '',
  },
  [MultiApprovalFieldName.Approver2]: {
    initialValue: '',
    validationRule: '',
  },
  [MultiApprovalFieldName.Approver3]: {
    initialValue: '',
    validationRule: '',
  },
};

export const ApproverLevelConstant = [
  {
    value: 'all_account',
    label: 'common_all_accounts',
    description: 'multiapproval_allacount_canbe',
  },
  {
    value: 'chosen_account',
    label: 'common_chosen_accounts',
    description: 'multiapproval_select_theaccount',
  },
];

export const ApproverConstant = [
  {
    value: 'all_account',
    label: 'common_all_accounts',
    description: 'multiapproval_allacount_canbe_nolevel',
  },
  {
    value: 'chosen_account',
    label: 'common_chosen_accounts',
    description: 'multiapproval_select_theaccount_nolevel',
  },
];

export const defaultApprovalLevel1: MultiApprovalData = {
  id: '',
  product: 'BULK_DISBURSEMENT',
  username: auth?.user?.company_username,
  minAmount: 0,
  approvalNeeded: 1,
  approvalLevel: 1,
  approvers: [],
  parent: false,
  usingChildAccount: false,
};

export const defaultApprovalLevel2: MultiApprovalData = {
  id: '',
  product: 'BULK_DISBURSEMENT',
  username: auth?.user?.company_username,
  minAmount: 0,
  approvalNeeded: 2,
  approvalLevel: 2,
  approvers: [],
  parent: false,
  usingChildAccount: false,
};

export const defaultApprovalLevel3: MultiApprovalData = {
  id: '',
  product: 'BULK_DISBURSEMENT',
  username: auth && auth.user && auth.user.company_username,
  minAmount: 0,
  approvalNeeded: 3,
  approvalLevel: 3,
  approvers: [],
  parent: false,
  usingChildAccount: false,
};

export const ChildApproverLevelConstant = [
  {
    value: 'all_parent_account',
    label: 'common_all_parent_account',
    description: 'multiapproval_all_parent_account_desc_',
  },
  {
    value: 'child_account',
    label: 'common_child_account',
    description: 'multiapproval_child_account_desc_',
  },
  {
    value: 'selected_parent_account',
    label: 'common_selected_parent_account',
    description: 'multiapproval_selected_parent_account_desc_',
  },
];

export const ChildApproverLevelMandatoryParentApprovalConstant = [
  {
    value: 'all_parent_account',
    label: 'common_all_parent_account',
    description: 'multiapproval_all_parent_account_desc_',
  },
  {
    value: 'selected_parent_account',
    label: 'common_selected_parent_account',
    description: 'multiapproval_selected_parent_account_desc_',
  },
];

export enum PermissionType {
  ALL_ACTOR = 'ALL_ACTOR',
  SPECIFIC_ACTOR = 'SPECIFIC_ACTOR',
}

export enum ActorType {
  INDIVIDUAL = 'INDIVIDUAL',
}

export enum ProductWorkflowRule {
  INTERNATIONAL_REMITTANCE = 'INTERNATIONAL_REMITTANCE',
  BULK_DISBURSEMENT = 'BULK_DISBURSEMENT',
}

export enum IsUsingChosenType {
  ALL_ACCOUNT = 'all_account',
  CHOSEN_ACCOUNT = 'chosen_account',
}

export type ApproverField = {
  value: string;
  label: string;
  role: string;
};

export const MAX_APPROVERS = 30;

export const sortByCreated = (
  a: GetApproverMakerData,
  b: GetApproverMakerData,
) => {
  if (a?.created && b?.created) {
    const dateA = new Date(a.created);
    const dateB = new Date(b.created);
    return dateA.getTime() - dateB.getTime();
  }

  return 0;
};

export const NewApproverLevelConstant = [
  {
    value: 'ALL_ACTOR',
    label: 'common_all_accounts',
    description: 'multiapproval_allacount_canbe',
  },
  {
    value: 'SPECIFIC_ACTOR',
    label: 'common_chosen_accounts',
    description: 'multiapproval_select_theaccount',
  },
];
